var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreeTrialPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 56,
    viewBox: "0 0 38 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_17",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0H34C36.2 0 38 1.8 38 4V52C38 54.2 36.2 56 34 56H4C1.8 56 0 54.2 0 52V4C0 1.8 1.8 0 4 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0H34C36.2 0 38 1.8 38 4V52C38 54.2 36.2 56 34 56H4C1.8 56 0 54.2 0 52V4C0 1.8 1.8 0 4 0Z",
    fill: "#E4ADBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1 9.9L14 10.5L17.2 16L18.3 15.4L15.1 9.9Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.9L10.9 14L16.5 17.2L17.1 16.1L11.5 12.9Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.3H10V18.6H16.5V17.3Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1 17.3H21.6V18.6H28.1V17.3Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12.9L21 16.1L21.6 17.2L27.2 14L26.5 12.9Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 9.9L19.8 15.4L20.9 16L24.1 10.5L23 9.9Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7 9H18.4V15.4H19.7V9Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 26,
    width: 34,
    height: 27,
    fill: "#E4ADBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2695 42H16.3135V32.1357H14.2627L11.7129 33.9062V35.7383L14.2285 34.0293H14.2695V42ZM23.2314 42H25.1934V40.1885H26.4922V38.541H25.1934V32.1357H22.2812L18.3232 38.4658V40.1885H23.2314V42ZM20.1211 38.5957V38.541L23.2246 33.626H23.2725V38.5957H20.1211Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8556 50H13.4967C14.7864 50 15.546 49.1988 15.546 47.8346V47.8287C15.546 46.4675 14.7835 45.702 13.4967 45.702H11.8556V50ZM12.7551 49.2554V46.4437H13.3895C14.1788 46.4437 14.6286 46.9351 14.6286 47.8316V47.8376C14.6286 48.7669 14.1937 49.2554 13.3895 49.2554H12.7551ZM15.8875 50H16.8317L17.1564 48.9575H18.6754L19.0001 50H19.9443L18.4461 45.702H17.3887L15.8875 50ZM17.907 46.536H17.9248L18.4669 48.2844H17.3649L17.907 46.536ZM21.2241 50H22.1236V48.3946L23.6218 45.702H22.6478L21.6858 47.5368H21.6649L20.6999 45.702H19.7289L21.2241 48.3946V50ZM25.5747 50.0745C26.6589 50.0745 27.3082 49.5502 27.3082 48.7252V48.7222C27.3082 48.0461 26.9032 47.6797 26.0036 47.501L25.5479 47.4087C25.0535 47.3104 24.8331 47.1525 24.8331 46.8815V46.8785C24.8331 46.5717 25.1101 46.3603 25.5718 46.3573C26.0156 46.3573 26.3253 46.5628 26.37 46.8994L26.373 46.9351H27.2219L27.2189 46.8785C27.1772 46.125 26.5666 45.6275 25.5718 45.6275C24.6186 45.6275 23.9336 46.1458 23.9336 46.9321V46.9351C23.9336 47.5814 24.3625 47.9865 25.2114 48.1563L25.6641 48.2457C26.1973 48.3559 26.4087 48.5018 26.4087 48.7937V48.7967C26.4087 49.1243 26.096 49.3417 25.5986 49.3417C25.1071 49.3417 24.7527 49.1333 24.6961 48.7997L24.6901 48.7669H23.8412L23.8442 48.8146C23.8949 49.6068 24.5531 50.0745 25.5747 50.0745Z",
    fill: "#F9F9F9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTrialPlan);
export default __webpack_public_path__ + "static/media/free-trial-plan.a023c6f7c609c7a698906d69488af53b.svg";
export { ForwardRef as ReactComponent };